export default "__VITE_ASSET__B0YuUkj7__"